import { Component, OnInit, Input, Inject, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';

import { BirdService } from './bird.service';
import { Taxo } from '../taxo/taxo';
import { PictureDialogComponent } from '../dialog/picture-dialog/picture-dialog.component';

@Component({
  selector: 'app-bird',
  templateUrl: './bird.component.html',
  styleUrls: ['./bird.component.scss']
})
export class BirdComponent implements OnInit {
  @Input() sciName = '';
  @Input() idioma = '';
  @Input() picsResolution: number;

  pictures = [];
  audios = [];
  colors = [];
  taxo: Taxo = new Taxo();
  maps = {
    audios: {
      set: false,
      lat: 0,
      lng: 0,
      zoom: 3
    },
    sights: {
      set: false,
      lat: 0,
      lng: 0,
      zoom: 3
    }
  };
  audioURI = null;
  xenocantoURI = null;
  loading = {
    taxo: true,
    sounds: true,
    pictures: true,
    colors: true,
    mp3: false
  };
  share = {
    facebook: ''
  };

  image = false;
  sonido = false;
  info = false;
  dialogPic = false;

  textArea = '';

  constructor(
    private birdService: BirdService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private chRef: ChangeDetectorRef,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) document: any
  ) {

  }

  getMp3(audio: any) {
    this.loading.mp3 = true;
    this.birdService
      .getSoundMP3(this.taxo.sciName, Number(audio.id))
      .subscribe((data: any) => {
        this.loading.mp3 = false;

        this.audioURI = data.response.file;
        this.xenocantoURI = data.response.url;
        this.chRef.detectChanges();
      });
  }

  getSounds() {
    this.loading.sounds = true;

    this.birdService
      .getSoundsBySciName(this.sciName)
      .subscribe((data: any) => {

        this.audios = data.response;
        this.loading.sounds = false;
        this.maps.audios.lat = data.response[0].lat;
        this.maps.audios.lng = data.response[0].lng;
      });
  }

  getTaxo() {
    this.loading.taxo = true;

    this.birdService
      .getTaxonInfo(this.sciName, this.idioma)
      .subscribe((data: any) => {

        if (data.response.length > 0) {
          this.taxo = data.response[0];
          this.taxo.bandingCodes = data.response[0]["BANDING-CODES"];
          this.taxo.category = data.response[0]["CATEGORY"];
          this.taxo.comName = data.response[0]["COM-NAME"];
          this.taxo.comNameCodes = data.response[0]["COM-NAME-CODE"];
          this.taxo.ebirdSpeciesGroup = data.response[0]["EBIRD-SPECIES-GROUP"];
          this.taxo.family = data.response[0]["FAMILY"];
          this.taxo.id = data.response[0]["ID"];
          this.taxo.idIdioma = data.response[0]["ID_IDIOMA"];
          this.taxo.pic = data.response[0]["PIC"];
          this.taxo.range = data.response[0]["RANGE"];
          this.taxo.sciName = data.response[0]["SCI-NAME"];
          this.taxo.sciNameCodes = data.response[0]["SCI-NAME-CODES"];
          this.taxo.speciesCode = data.response[0]["SPECIES-CODE"];
          this.taxo.taxonId = data.response[0]["TAXON-ID"];
          this.taxo.taxonOrder = data.response[0]["TAXON-ORDER"];

          this.titleService.setTitle(this.sciName + ' (' + this.taxo.comName + ') GlobalBirdWatching.org');

          this.metaService.updateTag({ property: 'og:url', content: document.location.href });
          this.metaService.updateTag({ property: 'og:type', content: 'website' });
          this.metaService.updateTag({ property: 'og:title', content: this.sciName + '/' + this.taxo.comName + '/GlobalBirdWatching.org' });
          this.metaService.updateTag({ property: 'og:description', content: 'Detalles de la Especie ' + this.sciName + '/' + this.taxo.comName });
          this.metaService.updateTag({ property: 'og:image', content: this.taxo.pic });

          this.share.facebook += '?type=website&title=' + escape(this.sciName) + '/' + escape(this.taxo.comName) + '/GlobalBirdWatching.org' + '&description=' + 'Detalles de la Especie ' + escape(this.sciName) + ' ' + escape(this.taxo.comName) + '&image=' + this.taxo.pic;

          this.textArea = 'category: ' + this.taxo.category + '\r\n' + '\r\n';

          if (this.taxo.comNameCodes) {
            this.textArea += 'com. name code: ' + this.taxo.comNameCodes + '\r\n' + '\r\n';
          }
          if (this.taxo.ebirdSpeciesGroup) {
            this.textArea += 'species group: ' + this.taxo.ebirdSpeciesGroup + '\r\n' + '\r\n';
          }
          if (this.taxo.family) {
            this.textArea += 'family: ' + this.taxo.family + '\r\n' + '\r\n';
          }
          if (this.taxo.range) {
            this.textArea += 'range: ' + this.taxo.range + '\r\n' + '\r\n';
          }
          if (this.taxo.taxonId) {
            this.textArea += 'taxo id: ' + this.taxo.taxonId + '\r\n' + '\r\n';
          }
          if (this.taxo.taxonOrder) {
            this.textArea += 'taxo order: ' + this.taxo.taxonOrder;
          }
        }

        this.loading.taxo = false;
      });
  }

  getPics() {
    this.loading.pictures = true;

    this.birdService
      .getPicsBySciName(this.sciName)
      .subscribe((data: any) => {

        this.pictures = data.response;

        this.loading.pictures = false;
      });
  }

  getColors() {
    this.loading.colors = true;

    this.birdService
      .getColors(this.sciName)
      .subscribe((data: any) => {

        this.colors = data.response;

        this.loading.colors = false;
      });
  }

  getBackgroundImageStyle(pImageUrl: string) {
    return {
      'background-image': 'url(' + pImageUrl + ')',
      'background-size': 'cover'
    }
  }

  getBackgroundColorStyle(pHexColor: string) {
    return {
      'background-color': pHexColor,
      'border': '1px solid #CCCCCC'
    }
  }

  openPictureDialog(pPictureURI: string, pAutor: string, pPictureURL: string, pTitulo: string) {
    let dialogRef = this.dialog.open(PictureDialogComponent, {
      data: {
        pictureURL: pPictureURI,
        pictureAutor: pAutor,
        pictureAutorUrl: pPictureURL,
        pictureTitle: pTitulo
      },
      width: '100vw',
      maxWidth: '100vw',
      minWidth: '100vw'
    });

    this.dialogPic = true;

    dialogRef.afterClosed().subscribe(result => {
      this.dialogPic = false;
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.sciName = params['sciname'];
      this.idioma = params['idioma'];
      this.share.facebook = document.location.href;
      this.getTaxo();
      this.getSounds();
      this.getPics();
      this.getColors();
    });
  }
}
